import { useEffect } from "react";
import { useSetRecoilState } from "recoil";
import { currentNewRequisition } from "../../recoil/atoms";
import { NewRequisitionForm } from "../../recoil/types";

export const useMirrorRequisitionToCreateOrderState = ({
  enabled,
  requisitionForm,
}: {
  enabled: boolean;
  requisitionForm: NewRequisitionForm;
}) => {
  const setNewGlobalRequisition = useSetRecoilState(currentNewRequisition);
  const requisitionFormToMirror = enabled ? requisitionForm : undefined;

  useEffect(() => {
    if (!requisitionFormToMirror) return;

    setNewGlobalRequisition((currentRequisition) => ({
      ...currentRequisition,
      ...requisitionFormToMirror,
    }));
  }, [requisitionFormToMirror, setNewGlobalRequisition]);
};
